<template lang="pug">
App(:navigationItems="navigationItems" :cartPrefix="CartPrefix.DIGITAL_MENU" :defaultSaletype="Saletype.DIGITAL_MENU")
</template>

<script setup lang="ts">
import App from "@/App.vue";
import { Saletype } from "@/models/App";
import { CartPrefix } from "@/models/Cart";
import type { Auth } from "@/plugins/auth";
import type { NavigationItem } from "@/types";
import { inject, type Ref } from "vue";
import { useRecaptchaProvider } from 'vue-recaptcha/head';

useRecaptchaProvider();
const auth = inject('auth') as Ref<Auth>;

if (auth.value.check()) auth.value.logout();

const navigationItems: NavigationItem[] = [
  {
    icon: "$orderLight",
    activeIcon: "$orderBold",
    link: { name: "order" }
  }
];
</script>
